import React, { Children } from 'react';
import { motion } from 'framer-motion';
export function FocusAreas() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: 'easeOut'
      }
    }
  };
  return <section className="py-32 md:py-48 px-6 flex flex-col items-center" data-id="element-22">
      <div className="w-full max-w-6xl" data-id="element-23">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-20 md:gap-8 relative" data-id="element-24">
          {/* Desktop Dividers */}
          <div className="hidden md:block absolute top-0 bottom-0 left-1/3 w-px bg-brand-gold/20 -translate-x-1/2" data-id="element-25" />
          <div className="hidden md:block absolute top-0 bottom-0 left-2/3 w-px bg-brand-gold/20 -translate-x-1/2" data-id="element-26" />

          {/* Area 1 */}
          <motion.div variants={itemVariants} className="flex flex-col items-center text-center px-4 md:px-12" data-id="element-27">
            <h3 className="font-heading text-xs md:text-sm tracking-widest uppercase text-brand-gold mb-8" data-id="element-28">
              Media
            </h3>
            <p className="font-heading text-xl md:text-2xl text-brand-warmGrey font-light leading-snug tracking-wide" data-id="element-29">
              Backing projects that shape culture
            </p>
          </motion.div>

          {/* Area 2 */}
          <motion.div variants={itemVariants} className="flex flex-col items-center text-center px-4 md:px-12" data-id="element-30">
            <h3 className="font-heading text-xs md:text-sm tracking-widest uppercase text-brand-gold mb-8" data-id="element-31">
              Technology
            </h3>
            <p className="font-heading text-xl md:text-2xl text-brand-warmGrey font-light leading-snug tracking-wide" data-id="element-32">
              Early-stage and emerging infrastructure
            </p>
          </motion.div>

          {/* Area 3 */}
          <motion.div variants={itemVariants} className="flex flex-col items-center text-center px-4 md:px-12" data-id="element-33">
            <h3 className="font-heading text-xs md:text-sm tracking-widest uppercase text-brand-gold mb-8" data-id="element-34">
              Opportunistic Investments
            </h3>
            <p className="font-heading text-xl md:text-2xl text-brand-warmGrey font-light leading-snug tracking-wide" data-id="element-35">
              High-conviction, asymmetric opportunities
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}